import { render, staticRenderFns } from "./AutoMeasure.vue?vue&type=template&id=447da454"
import script from "./AutoMeasure.vue?vue&type=script&lang=js"
export * from "./AutoMeasure.vue?vue&type=script&lang=js"
import style0 from "./AutoMeasure.vue?vue&type=style&index=0&id=447da454&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports